module.exports = __webpack_public_path__ + "static/media/es.2d6ddad0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/es.svg
// module id = 2085
// module chunks = 0